import * as React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { Rocket, CheckCircle } from 'lucide-mui';
import { useTranslation } from 'react-i18next';

import { RootState } from '../../../reducers';
import ActionButton from '../../plan/upgrade/ActionButton';
import usePlan from '../../plan/hooks/plan';
import useLimits from '../../plan/hooks/limits';
import { requestStatusType } from '../../../types';

const UpgradeButton = () => {
  const { t } = useTranslation();
  const guardLimits = useLimits();
  const { plan } = useSelector((state: RootState) => state);
  const { upgradeStatus } = plan.subscription;
  const handleClick = () => {
    guardLimits('generalUpgrade', () => {});
  };

  const { isPlan } = usePlan();
  const upgraded = isPlan(['GROWTH', 'BUSINESS', 'ENTERPRISE']);
  let status = upgradeStatus || 'idle';
  if (
    !upgraded &&
    (['failed', 'succeeded'] as requestStatusType[]).includes(upgradeStatus)
  ) {
    status = 'idle';
  }

  if (upgraded) {
    return null;
  }

  // Determine the icon to display based on the status
  const Icon = status === 'succeeded' ? CheckCircle : Rocket;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <ActionButton
        startIcon={<Icon />}
        variant="contained"
        color="primary"
        size="medium"
        onClick={handleClick}
        sx={{ minWidth: 'unset' }}
        flashTooltip={status !== 'idle'}
        tooltipMessage={t(`upgrade.tooltips.${status}`)}
        loading={status === 'pending'}
      >
        {t(`upgrade.buttons.${status}`).replace(/ /g, '\u00A0')}
      </ActionButton>
    </Box>
  );
};

export default UpgradeButton;
